module.exports = __webpack_public_path__ + "img/7B5254_E9DCC7_B19986_C8AC91-256px.fc661710.png";